import { render, staticRenderFns } from "./lk-lead-tile-item.vue?vue&type=template&id=0fe4d37c&"
import script from "./lk-lead-tile-item.vue?vue&type=script&lang=js&"
export * from "./lk-lead-tile-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/lk/lk-leads-list/lk-lead-tile-item.vue
// module id = 1443
// module chunks = 0